import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungPrioListStatus: 'idle',
    loadMeldungPrioListError: undefined as any,
    loadMeldungPrioListLastArgs: undefined as any,
    loadMeldungPrioStatus: 'idle',
    loadMeldungPrioError: undefined as any,
    saveMeldungPrioStatus: 'idle',
    saveMeldungPrioError: undefined as any,
    deleteMeldungPrioStatus: 'idle',
    deleteMeldungPrioError: undefined as any,

    meldungPrioList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungPrioList = createAsyncThunk('meldungPrioSlice/loadMeldungPrioList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungPrioSlice.loadMeldungPrioListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldprio/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungPrioListStatus } = getState().meldungPrioSlice
        return loadMeldungPrioListStatus !== 'pending'
    }
})

export const loadMeldungPrio = createAsyncThunk('meldungPrioSlice/loadMeldungPrio', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldprio/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungPrioStatus } = getState().meldungPrioSlice
        return loadMeldungPrioStatus !== 'pending'
    }
})

export const saveMeldungPrio = createAsyncThunk('meldungPrioSlice/saveMeldungPrio', async ({ meldungPrio }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungPrio?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldprio/${ meldungPrio?.HDR_ID }/`,
            prepareData(meldungPrio),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldprio/`,
            prepareData(meldungPrio),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungPrioStatus } = getState().meldungPrioSlice
        return saveMeldungPrioStatus !== 'pending'
    }
})

export const deleteMeldungPrio = createAsyncThunk('meldungPrioSlice/deleteMeldungPrio', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldprio/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungPrioStatus } = getState().meldungPrioSlice
        return deleteMeldungPrioStatus !== 'pending'
    }
})

const MeldungPrioSlice = createSlice({
    name: 'meldungPrioSlice',
    initialState,
    reducers: {
        resetloadMeldungPrioListError: (state) => {
            state.loadMeldungPrioListError = undefined
        },
        resetloadMeldungPrio: (state) => {
            state.formItem = undefined
            state.loadMeldungPrioError = undefined
        },
        resetloadMeldungPrioError: (state) => {
            state.loadMeldungPrioError = undefined
        },
        resetsaveMeldungPrio: (state) => {
            state.formItem = undefined
            state.saveMeldungPrioError = undefined
        },
        resetsaveMeldungPrioError: (state) => {
            state.saveMeldungPrioError = undefined
        },
        resetdeleteMeldungPrioError: (state) => {
            state.deleteMeldungPrioError = undefined
        },
        removeFromMeldungPrioListById: (state, action) => {
            state.meldungPrioList = state.meldungPrioList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungPrioListByIds: (state, action) => {
            state.meldungPrioList = state.meldungPrioList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungPrioList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungPrioListStatus = 'preloaded'
            state.loadMeldungPrioListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungPrioList = []
            state.loadMeldungPrioListStatus = 'idle'
            state.loadMeldungPrioListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungPrioList.pending, (state) => {
            state.loadMeldungPrioListStatus = 'pending'
            state.loadMeldungPrioListError = undefined
        })
        builder.addCase(loadMeldungPrioList.fulfilled, (state, action) => {
            state.loadMeldungPrioListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungPrioListLastArgs = action.payload.args

            {
                state.meldungPrioList = action.payload.data

            }
        })
        builder.addCase(loadMeldungPrioList.rejected, (state, action) => {
            state.loadMeldungPrioListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungPrioListError = action.error.message
            } else {
                state.loadMeldungPrioListError = action.payload
            }
        })

        builder.addCase(loadMeldungPrio.pending, (state) => {
            state.loadMeldungPrioStatus = 'pending'
            state.loadMeldungPrioError = undefined
        })
        builder.addCase(loadMeldungPrio.fulfilled, (state, action) => {
            state.loadMeldungPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungPrioList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungPrioList.push(newItem) }
                else { state.meldungPrioList[i] = { ...state.meldungPrioList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungPrio.rejected, (state, action) => {
            state.loadMeldungPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungPrioError = action.error.message
            } else {
                state.loadMeldungPrioError = action.payload
            }
        })

        builder.addCase(saveMeldungPrio.pending, (state) => {
            state.saveMeldungPrioStatus = 'pending'
            state.saveMeldungPrioError = undefined
        })
        builder.addCase(saveMeldungPrio.fulfilled, (state, action) => {
            state.saveMeldungPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungPrioList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungPrioList.push(newItem) }
                else { state.meldungPrioList[i] = { ...state.meldungPrioList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungPrio.rejected, (state, action) => {
            state.saveMeldungPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungPrioError = action.error.message
            } else {
                state.saveMeldungPrioError = action.payload
            }
        })

        builder.addCase(deleteMeldungPrio.pending, (state) => {
            state.deleteMeldungPrioStatus = 'pending'
            state.deleteMeldungPrioError = undefined
        })
        builder.addCase(deleteMeldungPrio.fulfilled, (state, action) => {
            state.deleteMeldungPrioStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungPrioList = state.meldungPrioList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungPrioList = state.meldungPrioList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungPrio.rejected, (state, action) => {
            state.deleteMeldungPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungPrioError = action.error.message
            } else {
                state.deleteMeldungPrioError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungPrioListError,
    resetloadMeldungPrio,
    resetloadMeldungPrioError,
    resetsaveMeldungPrio,
    resetsaveMeldungPrioError,
    resetdeleteMeldungPrioError,
    removeFromMeldungPrioListById,
    removeFromMeldungPrioListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungPrioSlice.actions
export default MeldungPrioSlice.reducer
